import FormattedMessage from 'I18n/components/FormattedMessage';
import { useSelector } from 'react-redux';
import { ValueProps } from '../../constants/ValueProps';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
// @ts-expect-error png import
import Support from 'bender-url!../../img/valuePropsSection/247Support.png';
// @ts-expect-error png import
import tailoredOnboarding from 'bender-url!../../img/valuePropsSection/tailoredOnboarding.png';
// @ts-expect-error png import
import freeOnlineTraining from 'bender-url!../../img/valuePropsSection/freeOnlineTraining.png';
import { Text } from 'foundations-components/components/Text';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { Image } from 'foundations-components/transitional/components/Image';
import { PageSection, SectionHeader, SectionTitle } from 'pricing-pages-ui-components/semantic/PageSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getValuePropImage = valueProp => {
  const valuePropToImageMap = {
    '247Support': Support,
    tailoredOnboarding,
    freeOnlineTraining
  };
  return valuePropToImageMap[valueProp];
};
const ValuePropsSection = () => {
  const isAppAuth = useSelector(isAppAuthSelector);
  if (isAppAuth) return null;
  return /*#__PURE__*/_jsxs(PageSection, {
    children: [/*#__PURE__*/_jsx(SectionHeader, {
      children: /*#__PURE__*/_jsx(SectionTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "valueProps.title"
        })
      })
    }), /*#__PURE__*/_jsx(CardGrid, {
      columns: 3,
      gutterSize: 32,
      children: ValueProps.map(valueProp => {
        return /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(Image, {
            src: getValuePropImage(valueProp),
            inlineSize: "100%",
            objectFit: "contain",
            role: "img"
          }), /*#__PURE__*/_jsx(Text, {
            as: "h3",
            typography: "heading-50",
            textAlign: "center",
            marginBlock: "400",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `valueProps.props.${valueProp}.name`
            })
          }), /*#__PURE__*/_jsx(Text, {
            as: "div",
            textAlign: "center",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `valueProps.props.${valueProp}.description`
            })
          })]
        }, valueProp);
      })
    })]
  });
};
export default ValuePropsSection;